import { Container, Row, Col, Form, Table } from "react-bootstrap"; 
import { motion } from "framer-motion";
import question1_image from "../../../images/trump.png"
import question2_image from "../../../images/athlete.png"
import question3_image from "../../../images/langlang.png"
import ai_welcome from "../../../images/Welcome_ai.png";

import '../StudyTwoInstruction.css';
import { useState } from 'react';


export default function StudyTwoInstructionSessionFour( {onSubmit} ){
    const options = ['Happy', 'Sad', 'Angry', 'Surprise', 'Neutral','Disgust','contempt','Fear'];
    const googleDriveVideoIds = ["1pWLde6TAq8PzeeujgWUkSl5IH-8Dgyj6",
        "1nbXb-XxAAv_oNgWWZMIpT6aB2ik3Bi8k",
        "1lhmwomJ3LFOfIqz7Wsbr5a66PvJ4n749"
    ]; 
    // const googleDriveEmbedLink = `https://drive.google.com/file/d/${googleDriveVideoId}/preview`;
    const [selectedAnswers, setSelectedAnswers] = useState({
        question1: '',
        question2: '',
        question3: '',
    });
    const aiAnswers = {
        question1: 'Disgust',
        question2: 'Surprise',
        question3: 'Sad',
    };
    const [selectedAnswer, setSelectedAnswer] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const handleSelectChange = (questionKey, event) => {
        setSelectedAnswers({
            ...selectedAnswers,
            [questionKey]: event.target.value
        });
    };
    const handleSubmit = () => {
        setSubmitted(true);

        if(onSubmit){
            onSubmit();
        }
    };
    const allAnswered = Object.values(selectedAnswers).every(answer => answer !== '');
    return (
        <Container className="study-item" style={{width:"90%"}}>
            <br />
            <Row>
            <h1 className="subtitle">Read other's emotions under social context!</h1>
                <Container>
                <p>Can we really infer people's emotions through facial expressions?</p>
                {!submitted ? (
                        <>
                            <h5>Here are three images. Please select the <strong className="highlight">primary emotion category</strong> for each.</h5>
                            <br />
                            <Row className="justify-content-center">
                                {[question1_image, question2_image, question3_image].map((image_src, questionNumber) => (
                                    <Col key={`question${questionNumber+1}`} md={3} className="text-center">
                                        <img
                                            style={{ width: '80%' }}
                                            src={image_src} 
                                            alt={`Question ${questionNumber+1}`}
                                        />
                                        <p>Question {questionNumber + 1}</p> {/* 添加图片标签 */}
                                        <Form.Group controlId={`emotionSelect${questionNumber+1}`}>
                                            <Form.Control
                                                as="select"
                                                value={selectedAnswers[`question${questionNumber+1}`]}
                                                onChange={(e) => handleSelectChange(`question${questionNumber+1}`, e)}
                                                className="form-select mt-3"
                                                style={{width:'100%'}}
                                            >
                                                <option value="">Select emotion</option>
                                                {options.map(option => (
                                                    <option key={option} value={option}>{option}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                ))}
                            </Row>
                            <div className="text-center mt-4">
                                <motion.button
                                    type="button"
                                    className={`button carousel-button ${allAnswered ? '' : 'button-disabled'}`}
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.8 }}
                                    onClick={handleSubmit}
                                    disabled={!allAnswered}
                                >
                                    Submit
                                </motion.button>
                            </div>
                        </>
                    ) : (
                        <Row className="align-items-start mb-4">
                        <Col xs={4} className="text-center">
                            <img 
                                src={ai_welcome} 
                                alt="FEAI icon" 
                                style={{ width: "150px", height: "150px", }} 
                            />
                        </Col>
                        <Col xs={7}>
                    
                        <div className="chat-bubble">
                            <p>
                            We may disagree with each other.But do you trust your answers?         
                            </p>
                        </div>
                        </Col>
                        </Row> 
                    )}
                    <br />
                {submitted && (
                    <div>
                        <h4>Summary</h4> 
                        <div className="mt-3" style={{textAlign:'center'}}>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <td></td>
                                        <th><img src={question1_image} style={{width:'40%'}} alt="question_one" /></th>
                                        <th><img src={question2_image} style={{width:'40%'}} alt="question_two" /></th>
                                        <th><img src={question3_image} style={{width:'40%'}} alt="question_three" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>Your Answers</strong></td>
                                        {Object.keys(selectedAnswers).map((questionKey) => (
                                            <td key={questionKey}>{selectedAnswers[questionKey]}</td>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td><strong>AI Answers</strong></td>
                                        {Object.keys(aiAnswers).map((questionKey) => (
                                            <td key={questionKey}>{aiAnswers[questionKey]}</td>
                                        ))}
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                        <p className="highlight sentence">Watch the three videos below. What do you think of your answers and the AI’s answers now? </p>
                        <br /> 
                        <Row>
                            {googleDriveVideoIds.map((videoId, index) => (
                                <Col key={`video${index + 1}`}  xs={12} sm={6} md={4} className="text-center mb-4 video-wrapper">
                                    <iframe
                                        src={`https://drive.google.com/file/d/${videoId}/preview`}
                                        allow="autoplay"
                                        className="video-iframe"
                                        style={{ width: "100%", height: "auto" }}
                                    ></iframe>
                                    <p>Video {index + 1}</p>
                                </Col>
                            ))}
                        </Row>
                    </div>
                    )}
                </Container>
            </Row>
        </Container>
    );
};